import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagCustomersByPurchasedProducts",
    title: "Auto Tag Customers By Purchased Products",
    description: "Automatically tag customers based on the products that were purchased.",
    example: "Tag a customer based on the tags of the products that were purchased.",
    additional: [

    ],
    legacy: false,
    inProgress: false,
    allowPreview: false,
    previewType: "CustomerTags",
    dataPermissions: ["products", "customers", "orders"],
    tags: ["Customers", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagCustomersByPurchasedProducts",
                tagByPurchasedProductTags: null,
                tagByPurchasedProductId: null
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                   
                },
            ], null);
    }
};

export default ruleDefinition;